import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import secureStorage from '../services/secureStorage';
import type {
  QuickAssistTechnicianItem,
  Pagination,
} from '../../features/dashboard/components/WorkOrders/WorkOrderProps';

export const SHOW_QUICK_ASSIST_KEY = 'show_quick_assist';
export const QUICK_ASSIST_SHOP_ID_KEY = 'quick_assist_shop_id';

export interface QuickAssistState {
  showQuickAssistScreen: boolean;
  initialTechnicians: QuickAssistTechnicianItem[];
  initialPagination: Pagination | null;
  initialShopId: number;
  initialPageSize: number;
}

const initialState: QuickAssistState = {
  showQuickAssistScreen: false,
  initialTechnicians: [],
  initialPagination: null,
  initialShopId: 0,
  initialPageSize: 9,
};

export interface SetQuickAssistDataPayload {
  initialTechnicians: QuickAssistTechnicianItem[];
  initialPagination: Pagination | null;
  initialShopId: number;
  initialPageSize: number;
}

const quickAssistSlice = createSlice({
  name: 'quickAssist',
  initialState,
  reducers: {
    openQuickAssistScreen(
      state,
      action: PayloadAction<SetQuickAssistDataPayload>,
    ) {
      state.showQuickAssistScreen = true;
      state.initialTechnicians = action.payload.initialTechnicians;
      state.initialPagination = action.payload.initialPagination;
      state.initialShopId = action.payload.initialShopId;
      state.initialPageSize = action.payload.initialPageSize;
      secureStorage.setItem(SHOW_QUICK_ASSIST_KEY, 'true').catch(() => {});
      secureStorage
        .setItem(QUICK_ASSIST_SHOP_ID_KEY, String(action.payload.initialShopId))
        .catch(() => {});
    },
    closeQuickAssistScreen(state) {
      state.showQuickAssistScreen = false;
      state.initialTechnicians = [];
      state.initialPagination = null;
      state.initialShopId = 0;
      state.initialPageSize = 9;
      secureStorage.removeItem(SHOW_QUICK_ASSIST_KEY).catch(() => {});
      secureStorage.removeItem(QUICK_ASSIST_SHOP_ID_KEY).catch(() => {});
    },
    setShowQuickAssistScreen(state, action: PayloadAction<boolean>) {
      state.showQuickAssistScreen = action.payload;
      if (!action.payload) {
        secureStorage.removeItem(SHOW_QUICK_ASSIST_KEY).catch(() => {});
        secureStorage.removeItem(QUICK_ASSIST_SHOP_ID_KEY).catch(() => {});
      }
    },
    /** Rehydration-only: restores initialShopId from secureStorage after a page reload. */
    setQuickAssistShopId(state, action: PayloadAction<number>) {
      state.initialShopId = action.payload;
    },
  },
});

export const {
  openQuickAssistScreen,
  closeQuickAssistScreen,
  setShowQuickAssistScreen,
  setQuickAssistShopId,
} = quickAssistSlice.actions;

export default quickAssistSlice.reducer;